/**
 * Determine whether a value is a BigInt string
 */
export function isBigInt(maybeBigInt) {
    // Fast typeof and string position check first
    if (typeof maybeBigInt === "string" && maybeBigInt.slice(-1) === "n") {
        // Slower RegExp match for strings ending with the BigInt suffix
        if (maybeBigInt.match(/^\d+n$/)) {
            return true;
        }
    }
    return false;
}
